// YDG WRLD JEWELS — "It's Been Everywhere" — Ch.0 TOUCHDOWN + Ch.1 THE SHATTER

gsap.registerPlugin(ScrollTrigger);

// ============ SITE NAV ============
(function siteNav() {
  const nav = document.getElementById('siteNav');
  const menuBtn = document.getElementById('navMenuBtn');
  const menu = document.getElementById('navMenu');
  const searchBtn = document.getElementById('navSearchBtn');
  const searchBar = document.getElementById('navSearchBar');
  const searchInput = document.getElementById('navSearchInput');
  const searchResults = document.getElementById('navSearchResults');
  if (!nav) return;

  // Solid/blurred bar once scrolled past the hero fold
  window.addEventListener('scroll', () => {
    nav.classList.toggle('is-scrolled', window.scrollY > 80);
  }, { passive: true });

  // Full-screen menu toggle
  if (menuBtn && menu) {
    menuBtn.addEventListener('click', () => {
      const open = menu.classList.toggle('is-open');
      menuBtn.classList.toggle('is-open', open);
      menuBtn.setAttribute('aria-expanded', String(open));
      menu.setAttribute('aria-hidden', String(!open));
      if (open) { searchBar?.classList.remove('is-open'); searchBtn?.setAttribute('aria-expanded', 'false'); }
    });
    menu.querySelectorAll('a').forEach((a) => a.addEventListener('click', () => {
      menu.classList.remove('is-open');
      menuBtn.classList.remove('is-open');
      menuBtn.setAttribute('aria-expanded', 'false');
      menu.setAttribute('aria-hidden', 'true');
    }));
  }

  // Search bar toggle + live filter over YDG_PRODUCTS
  if (searchBtn && searchBar && searchInput && searchResults) {
    const allProducts = (typeof YDG_PRODUCTS === 'object' && YDG_PRODUCTS)
      ? Object.values(YDG_PRODUCTS).flat()
      : [];

    const renderResults = (query) => {
      const q = query.trim().toLowerCase();
      if (!q) { searchResults.innerHTML = ''; return; }
      const matches = allProducts
        .filter((p) => p.title.toLowerCase().includes(q))
        .slice(0, 8);
      if (!matches.length) {
        searchResults.innerHTML = '<p class="nav-search-empty">No matches. Try WRLD CROSS, a colorway, or metal.</p>';
        return;
      }
      searchResults.innerHTML = matches.map((p) => (
        `<a href="/pages/product-1?handle=${encodeURIComponent(p.handle)}">
          <span>${p.title}</span><span>$${p.price}</span>
        </a>`
      )).join('');
    };

    searchBtn.addEventListener('click', () => {
      const open = searchBar.classList.toggle('is-open');
      searchBtn.setAttribute('aria-expanded', String(open));
      if (open) { setTimeout(() => searchInput.focus(), 200); }
    });
    searchInput.addEventListener('input', () => renderResults(searchInput.value));
  }
})();

// Only normalize scroll on touch devices. normalizeScroll() exists to fix
// touch-scroll quirks (needed here so the mobile World Tour swipe carousel,
// .wt-track, can still handle its own nested touch gestures via
// allowNestedScroll) -- but running it on desktop alongside Lenis means
// TWO independent scroll-smoothing engines are both re-interpreting the
// same wheel/trackpad input at once. On a big fast scroll throw they fight
// each other for control of the scroll position, which is exactly what
// reads as skippy/jittery motion. Lenis alone already smooths mouse-wheel/
// trackpad input perfectly, so normalizeScroll is skipped entirely there.
const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
if (isTouchDevice) {
  ScrollTrigger.normalizeScroll({ allowNestedScroll: true });
}
ScrollTrigger.config({ ignoreMobileResize: true });

// ============ SMOOTH SCROLL (Lenis + GSAP ticker) ============
// duration reduced from 1.35 -> 0.9: Lenis smooths raw scroll input, and
// every pinned/scrubbed GSAP timeline below smooths it *again* via its
// own `scrub` value -- stacking two rounds of lag on top of each other
// is what reads as "jittery"/"laggy catch-up" on fast scrolling. A
// shorter Lenis duration keeps the page tracking closer to real input
// while still feeling smooth, since GSAP's scrub adds its own easing.
const lenis = new Lenis({
  duration: 0.9,
  easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
  smoothWheel: true,
  syncTouch: true,
  wheelMultiplier: 1,
  touchMultiplier: 1.6,
});
lenis.on('scroll', ScrollTrigger.update);
gsap.ticker.add((time) => { lenis.raf(time * 1000); });
gsap.ticker.lagSmoothing(0);

// Keep pin/scrub math in sync once videos report their real dimensions/duration
// (prevents a visible "jump" partway through a pin when layout recalculates late).
window.addEventListener('load', () => ScrollTrigger.refresh());

// ============ CHAPTER 0 — HERO KINETIC HEADLINE (compress/settle on load) ============
(function heroIntro() {
  const headline = document.getElementById('heroHeadline');
  if (!headline) return;

  // Split each .hl-line into chars
  headline.querySelectorAll('.hl-line').forEach((line) => {
    const text = line.textContent;
    line.textContent = '';
    for (const ch of text) {
      const span = document.createElement('span');
      span.className = 'char';
      span.innerHTML = ch === ' ' ? '&nbsp;' : ch;
      line.appendChild(span);
    }
  });

  const chars = headline.querySelectorAll('.char');
  const tl = gsap.timeline({ delay: 0.15 });

  // Chars start oversized + spread, compress hard into place
  tl.fromTo(chars,
    { scale: 2.6, opacity: 0, yPercent: 18, transformOrigin: '50% 100%' },
    {
      scale: 1, opacity: 1, yPercent: 0,
      duration: 0.55,
      ease: 'power4.in',
      stagger: { each: 0.028, from: 'random' },
    }
  )
  // Settle: tiny overshoot squash then rest
  .to(chars, {
    scaleY: 0.88, duration: 0.09, ease: 'power2.out',
  })
  .to(chars, {
    scaleY: 1, duration: 0.35, ease: 'elastic.out(1.4, 0.4)',
  })
  .to('.hero-cta', { opacity: 1, duration: 0.5, ease: 'power2.out' }, '-=0.35')
  .to('.hero-scroll-hint', { opacity: 0.85, duration: 0.5, ease: 'power2.out' }, '-=0.2')
  .call(() => {
    gsap.to('.hero-scroll-hint', {
      opacity: 1, duration: 1.3, ease: 'sine.inOut',
      repeat: -1, yoyo: true,
    });
  });
})();

// ============ CHAPTER 0 — HERO EXIT (fade/darken in place, no movement) ============
(function heroExit() {
  const frame = document.getElementById('heroFrame');
  const shade = document.getElementById('heroExitShade');
  if (!frame || !shade) return;

  // Note: darkening is done via a plain opacity tween on an overlay div
  // (.hero-exit-shade), NOT a CSS `filter` on an ancestor of the <video>.
  // Animating `filter` on a video's ancestor forces some browsers to
  // re-composite/re-decode the video layer, which visibly flashes black
  // and restarts playback on scroll -- that was the root cause of the
  // "scroll a little, hero goes black and restarts" bug.
  gsap.timeline({
    scrollTrigger: {
      trigger: '#touchdown',
      start: 'top top',
      end: 'bottom top',
      scrub: 0.6,
    }
  })
  .to(shade, {
    opacity: 0.65,
    ease: 'none',
  }, 0)
  .to('.hero-content', {
    opacity: 0,
    ease: 'none',
  }, 0);
})();

// ============ CHAPTER 1 — THE SHATTER (pinned scroll-scrubbed video) ============
(function shatterChapter() {
  const video = document.querySelector('.shatter-video');
  const stage = document.querySelector('.shatter-stage');
  if (!video || !stage) return;

  // Pick the correct video src via JS based on actual viewport width
  // instead of relying on <source media="..."> -- Safari (especially
  // iOS) has a long-standing bug where it can silently pick the wrong
  // <source> for the current media query, loading the desktop 16:9
  // landscape video on a phone. object-fit:cover then crops that wide
  // video into the narrow 9:16 box, which reads exactly like the video
  // being "zoomed in" -- this is what was actually happening.
  const mobileSrc = video.dataset.srcMobile;
  const desktopSrc = video.dataset.srcDesktop;
  video.src = (window.innerWidth <= 767 && mobileSrc) ? mobileSrc : desktopSrc;
  video.load();

  // iOS Safari will not render any frames from a scrubbed `currentTime`
  // change until the video has actually been played at least once --
  // without this priming step, mobile Safari shows a blank video for
  // the entire scroll-scrub (desktop doesn't have this restriction).
  // A play() call fired on page load with no user gesture is silently
  // rejected by iOS's autoplay policy, so priming must happen on the
  // user's FIRST real interaction (touch/scroll/click) instead.
  let primed = false;
  const primeVideoForScrub = () => {
    if (primed) return;
    const p = video.play();
    if (p && typeof p.then === 'function') {
      p.then(() => { primed = true; video.pause(); }).catch(() => {});
    } else {
      primed = true;
      video.pause();
    }
  };
  // Try immediately (works if muted+playsinline autoplay is allowed),
  // then retry on the user's first real interaction as a fallback for
  // any iOS versions/contexts that reject the unprompted attempt.
  if (video.readyState >= 2) primeVideoForScrub();
  else video.addEventListener('loadeddata', primeVideoForScrub, { once: true });
  ['touchstart', 'scroll', 'pointerdown', 'click'].forEach((evt) => {
    window.addEventListener(evt, primeVideoForScrub, { passive: true });
  });

  // Split each shatter headline word into individual letter spans so they
  // can be blown apart / reassembled like debris, in sync with the video.
  const shWords = gsap.utils.toArray('.sh-word');
  const shChars = {};
  shWords.forEach((word) => {
    const key = word.dataset.word;
    const text = word.textContent;
    word.textContent = '';
    const chars = [];
    for (const ch of text) {
      const span = document.createElement('span');
      span.className = 'sh-char';
      span.innerHTML = ch === ' ' ? '&nbsp;' : ch;
      word.appendChild(span);
      chars.push(span);
    }
    shChars[key] = chars;
  });
  // Fixed pseudo-random scatter targets per char (stable across replays)
  const scatterFor = (chars) => chars.map((_, i) => {
    const seed = i * 137.5;
    const ang = (seed % 360) * (Math.PI / 180);
    const dist = 90 + (seed % 140);
    return {
      x: Math.cos(ang) * dist,
      y: Math.sin(ang) * dist - 40,
      rot: (seed % 220) - 110,
    };
  });
  const builtScatter = scatterFor(shChars.built);
  const brokenScatter = scatterFor(shChars.broken);
  const rebuiltScatter = scatterFor(shChars.rebuilt);

  // Longer pin than before — gives the scrub room to breathe instead of
  // feeling rushed/linear, which was reading as jarring against the
  // hero's slow scroll-scrub video and the World Tour's slow pinned scroll.
  const PIN_LENGTH = () => window.innerHeight * 3.2;

  // Master scrubbed timeline across the pin
  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: '#shatter',
      start: 'top top',
      end: () => '+=' + PIN_LENGTH(),
      pin: true,
      scrub: 0.6,
      anticipatePin: 1,
      invalidateOnRefresh: true,
      fastScrollEnd: true,
    }
  });

  // Entry veil: fades OUT over the first sliver of the pin so the section
  // doesn't hard-cut from the hero straight into an already-mid-shatter
  // video frame. No exit veil anymore -- the reassembled pendant's last
  // frame just stays on screen as-is (see tl.set(video, ...) below) right
  // up until World Tour's pin takes over, instead of fading everything to
  // an empty black hold that read as a long dead gap between chapters.
  tl.to('#shatterVeilIn', { opacity: 0, duration: 0.10, ease: 'power1.out' }, 0);

  // Video scrub: eased rather than linear. Hangs slightly longer on the
  // shattered/scattering state early on (so it reads as a deliberate
  // "broken" beat, matching the BUILT/BROKEN/REBUILT copy pacing) then
  // accelerates into the reassembly — feels directed instead of a flat
  // 1:1 scroll-to-frame mapping.
  const attachVideoScrub = () => {
    if (!video.duration) return;
    tl.to(video, {
      currentTime: video.duration,
      ease: 'power1.in',
      duration: 0.88,
    }, 0.10);
  };
  if (video.readyState >= 1) {
    attachVideoScrub();
  } else {
    video.addEventListener('loadedmetadata', attachVideoScrub, { once: true });
  }

  // ---- KINETIC TYPE VFX, synced to the video's break/reassemble beats ----
  // Each word: flies in from its scattered position, holds fully assembled
  // and visible, then (for BUILT/BROKEN) blows back apart before the next
  // word takes over — so it visibly reads as "coming together" and
  // "breaking apart", not just a flat fade.

  // BUILT. assembles first, holds, then shatters apart as BROKEN. arrives.
  tl.fromTo(shChars.built, {
      opacity: 0, x: (i) => builtScatter[i].x, y: (i) => builtScatter[i].y,
      rotate: (i) => builtScatter[i].rot, scale: 1.3,
    }, {
      opacity: 1, x: 0, y: 0, rotate: 0, scale: 1,
      duration: 0.06, stagger: 0.006, ease: 'power2.out',
    }, 0.04)
    // hold assembled
    .to(shChars.built, {
      x: (i) => builtScatter[i].x, y: (i) => builtScatter[i].y,
      rotate: (i) => builtScatter[i].rot, opacity: 0,
      duration: 0.08, stagger: 0.005, ease: 'power2.in',
    }, 0.16);

  // BROKEN. snaps together clean and readable first (same as BUILT), holds
  // briefly so it's actually legible, THEN violently explodes apart in sync
  // with the video's shatter beat, and fades out scattered.
  // NOTE: each stage below starts strictly after the previous one fully
  // finishes (no overlapping start times) — an earlier version had the
  // explosion tween starting before the assembly tween completed, which
  // overwrote it mid-flight and the word never actually snapped together.
  tl.fromTo(shChars.broken, {
      opacity: 0, x: (i) => brokenScatter[i].x, y: (i) => brokenScatter[i].y,
      rotate: (i) => brokenScatter[i].rot, scale: 1.3,
    }, {
      opacity: 1, x: 0, y: 0, rotate: 0, scale: 1,
      duration: 0.04, stagger: 0.004, ease: 'power2.out',
    }, 0.22)
    // brief legible hold — fully assembled, nothing moving. Starts AFTER the
    // slowest staggered char above has landed (0.22 + 0.04 + 6*0.004 = 0.284)
    .to(shChars.broken, {
      opacity: 1, duration: 0.05, ease: 'none',
    }, 0.29)
    // violent explosion apart — starts only after the hold above finishes
    .to(shChars.broken, {
      x: (i) => brokenScatter[i].x * 1.6, y: (i) => brokenScatter[i].y * 1.6,
      rotate: (i) => brokenScatter[i].rot * 1.3,
      duration: 0.13, stagger: { each: 0.005, from: 'random' }, ease: 'power3.out',
    }, 0.34)
    .to(shChars.broken, {
      opacity: 0, duration: 0.1, ease: 'power1.in',
    }, 0.48);

  // REBUILT. slams together from scattered debris exactly as the video
  // finishes reassembling — chars fly in from random directions and
  // punch-settle with an overshoot, then holds clean through the end.
  tl.fromTo(shChars.rebuilt, {
      opacity: 0, x: (i) => rebuiltScatter[i].x * 1.6, y: (i) => rebuiltScatter[i].y * 1.6,
      rotate: (i) => rebuiltScatter[i].rot * 1.4, scale: 0.4,
    }, {
      opacity: 1, x: 0, y: 0, rotate: 0, scale: 1.12,
      duration: 0.12, stagger: { each: 0.01, from: 'random' }, ease: 'power4.in',
    }, 0.68)
    .to(shChars.rebuilt, {
      scale: 1, duration: 0.08, ease: 'elastic.out(1.2, 0.35)',
    }, 0.80);

  // Spec callouts: snap in at frame markers, hold long, fade late
  const specs = [
    { sel: '.spec-1', on: 0.24, off: 0.60 },
    { sel: '.spec-2', on: 0.34, off: 0.68 },
    { sel: '.spec-3', on: 0.44, off: 0.76 },
    { sel: '.spec-4', on: 0.54, off: 0.84 },
  ];
  specs.forEach(({ sel, on, off }) => {
    tl.fromTo(sel,
      { opacity: 0, scale: 0.82 },
      { opacity: 1, scale: 1, duration: 0.05, ease: 'power2.out' }, on)
      .to(sel, { opacity: 0, scale: 0.92, duration: 0.05, ease: 'power1.in' }, off);
  });

  // NOTE: the reassembled pendant still is already handled by the video
  // scrub tween above (attachVideoScrub runs currentTime all the way to
  // video.duration by ~0.98 of the pin) -- there used to ALSO be a hard
  // tl.set(video, {currentTime: video.duration}, 0.92) here to "lock in"
  // the final still frame. That was actually fighting the still-running
  // eased scrub tween: the .set() would instantly snap to the last frame,
  // then the scrub tween (still animating toward that same end value on
  // its own eased curve) would immediately yank currentTime back to an
  // earlier frame before catching back up -- visible as the quick flash
  // of the pendant/shatter pieces right after the spec callouts fade.
  // Removed; the scrub tween alone already lands cleanly on the last frame.

  // Scroll hint fades in once the pendant is fully reassembled and held,
  // giving a clear cue to keep going into World Tour instead of the
  // section just... stopping.
  tl.to('#shatterScrollHint', { opacity: 0.7, duration: 0.05, ease: 'none' }, 0.93)
    .to('#shatterScrollHint', { opacity: 0, duration: 0.03, ease: 'none' }, 0.99);
})();

// ============ CHAPTER 2 — THE WORLD TOUR ============
// Desktop: pinned horizontal scroll (mouse-wheel scrubs the track).
// Mobile (<=767px): native touch-swipe carousel instead -- scroll-wheel
// pinning doesn't translate to a good touch feel, swiping city-to-city
// does. See worldTourMobile() below; this function early-returns on
// mobile so the two code paths never both run against the same DOM.
(function worldTourMobile() {
  if (window.innerWidth > 767) return;
  const track = document.getElementById('wtTrack');
  if (!track) return;

  const stops = gsap.utils.toArray('.wt-stop');
  const videos = gsap.utils.toArray('.wt-video');
  // PERF: don't fetch all 6 city videos (~30-40MB) on page load -- only
  // assign a src (and start the download) the moment a panel is about
  // to be shown. Same Safari <source media> bug as the Shatter video --
  // pick the right file explicitly via JS instead of trusting the
  // browser to choose correctly between the 9:16 and 16:9 sources.
  function assignSrc(v) {
    if (v.dataset.srcAssigned) return;
    const src = (window.innerWidth <= 767 && v.dataset.srcMobile) ? v.dataset.srcMobile : v.dataset.srcDesktop;
    if (src) { v.src = src; v.load(); v.dataset.srcAssigned = '1'; }
  }
  videos.forEach((v) => v.pause());
  // Only load the first city's video eagerly; the rest load lazily as
  // the user swipes near them (see updateActiveVideo below).
  if (videos[0]) assignSrc(videos[0]);

  // Only the panel currently snapped into view should be playing --
  // saves battery/CPU and avoids 7 videos decoding at once on a phone.
  function updateActiveVideo() {
    const scrollLeft = track.scrollLeft;
    const panelWidth = track.clientWidth || window.innerWidth;
    const idx = Math.round(scrollLeft / panelWidth);
    const panels = gsap.utils.toArray('.wt-panel', track);
    panels.forEach((panel, i) => {
      const v = panel.querySelector('.wt-video');
      if (!v) return;
      // Preload the active panel and the very next one so swiping
      // forward feels instant, without fetching all 6 at once.
      if (i === idx || i === idx + 1) assignSrc(v);
      if (i === idx) { if (v.paused) v.play().catch(() => {}); }
      else if (!v.paused) v.pause();
    });
  }
  updateActiveVideo();
  track.addEventListener('scroll', () => {
    clearTimeout(track._wtScrollTimer);
    track._wtScrollTimer = setTimeout(updateActiveVideo, 80);
  }, { passive: true });

  // Swipe hint on the first city (Marbella): fade in once it's actually
  // on screen, fade out permanently the moment the user swipes at all.
  const hint = document.getElementById('wtSwipeHint');
  if (hint) {
    setTimeout(() => hint.classList.add('is-visible'), 600);
    track.addEventListener('scroll', () => {
      if (track.scrollLeft > 20) hint.classList.remove('is-visible');
    }, { passive: true, once: true });
  }

  // City name reveal: simple fade/settle the moment each panel is in
  // view, driven by IntersectionObserver instead of the desktop's
  // scroll-scrub timeline (there's no pinned scrub progress on mobile).
  const io = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const city = entry.target.querySelector('.wt-city-inner');
      if (!city) return;
      if (entry.isIntersecting) {
        gsap.to(city, { opacity: 0.94, y: 0, duration: 0.5, ease: 'power1.out' });
      }
    });
  }, { root: track, threshold: 0.6 });
  stops.forEach((stop) => {
    const city = stop.querySelector('.wt-city-inner');
    if (city) gsap.set(city, { opacity: 0, y: 22 });
    io.observe(stop);
  });

  // Intro headline (V-formation flying-char effect) still plays once,
  // simply, the moment it scrolls into view -- no pin/scrub needed.
  const vHeadline = document.getElementById('wtVHeadline');
  if (vHeadline) {
    const lines = gsap.utils.toArray('.wtv-line', vHeadline);
    lines.forEach((line) => {
      const nodes = [...line.childNodes];
      line.innerHTML = '';
      nodes.forEach((node) => {
        const isHighlight = node.nodeType === 1 && node.classList && node.classList.contains('hl-gold');
        const text = node.textContent;
        [...text].forEach((ch) => {
          const span = document.createElement('span');
          span.className = 'wtv-char' + (isHighlight ? ' hl-gold' : '');
          span.textContent = ch === ' ' ? '\u00A0' : ch;
          line.appendChild(span);
        });
      });
    });
    const chars = gsap.utils.toArray('.wtv-char', vHeadline);
    gsap.set(chars, {
      x: () => (Math.random() - 0.5) * window.innerWidth * 0.9,
      y: () => (Math.random() - 0.5) * window.innerHeight * 0.5,
      rotate: () => (Math.random() - 0.5) * 220,
      opacity: 0,
    });
    gsap.to(chars, {
      x: 0, y: 0, rotate: 0, opacity: 1,
      duration: 0.8,
      ease: 'power3.out',
      stagger: { each: 0.012, from: 'random' },
      scrollTrigger: { trigger: '#worldtour', start: 'top 80%', toggleActions: 'play none none reverse' },
    });
  }
  gsap.fromTo('.wt-intro-sub, .wt-scroll-hint',
    { opacity: 0, y: 26 },
    { opacity: 1, y: 0, stagger: 0.08, duration: 0.5, ease: 'power2.out',
      scrollTrigger: { trigger: '#worldtour', start: 'top 60%', toggleActions: 'play none none reverse' } });
  const globeGrid = document.getElementById('wtGlobeGrid');
  if (globeGrid) {
    gsap.to(globeGrid, { opacity: 1, duration: 0.8, ease: 'power1.out',
      scrollTrigger: { trigger: '#worldtour', start: 'top 80%', toggleActions: 'play none none reverse' } });
  }
})();

(function worldTour() {
  if (window.innerWidth <= 767) return; // handled by worldTourMobile() above
  const track = document.getElementById('wtTrack');
  const viewport = document.querySelector('.wt-viewport');
  if (!track || !viewport) return;

  const panels = gsap.utils.toArray('.wt-panel');       // 7 = intro + 6 stops
  const stops = gsap.utils.toArray('.wt-stop');          // 6 cities
  const videos = gsap.utils.toArray('.wt-video');
  const N = panels.length;
  const SEG = 1 / (N - 1); // timeline progress per panel-to-panel move

  // PERF: don't fetch all 6 city videos (~30-40MB) up front -- assign
  // src lazily as the scrub timeline approaches each stop (see
  // onUpdate below). Only preload the first stop eagerly.
  function assignSrc(v) {
    if (!v || v.dataset.srcAssigned) return;
    if (v.dataset.srcDesktop) { v.src = v.dataset.srcDesktop; v.load(); v.dataset.srcAssigned = '1'; }
  }
  videos.forEach((v) => v.pause());
  assignSrc(stops[0] && stops[0].querySelector('.wt-video'));

  const PIN_LENGTH = () => window.innerHeight * (N * 1.6);

  // Master scrubbed timeline: translate the track across N-1 viewport widths
  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: '#worldtour',
      start: 'top top',
      end: () => '+=' + PIN_LENGTH(),
      pin: true,
      scrub: 0.6,
      anticipatePin: 1,
      invalidateOnRefresh: true,
      fastScrollEnd: true,
      onUpdate(self) {
        // Gold flight-path progress line
        gsap.set('#wtProgressFill', { scaleX: self.progress });

        // Video play/pause: only the active panel's video runs
        const idx = Math.round(self.progress * (N - 1));
        stops.forEach((stop, i) => {
          const v = stop.querySelector('.wt-video');
          if (!v) return;
          const active = (i + 1) === idx; // stops start at panel index 1
          // Preload active + next stop's video just ahead of arrival
          // instead of fetching all 6 at page load.
          if (active || i === idx) assignSrc(v);
          if (active && v.paused) { v.play().catch(() => {}); }
          else if (!active && !v.paused) { v.pause(); }
        });
      },
    }
  });

  // Track slide starts a bit into the timeline (after INTRO_HOLD) so the
  // V-formation headline reveal below gets its own dedicated on-screen
  // window while pinned, instead of the track already sliding away under it.
  const INTRO_HOLD = SEG * 0.28;
  tl.to(track, {
    xPercent: -100 * (N - 1) / N,
    ease: 'none',
    duration: 1 - INTRO_HOLD,
  }, INTRO_HOLD);

  // City-name subtle drift: each name now sits in its own off-center spot
  // (see CSS per-city positions -- moved off dead-center so it stops
  // blocking the pendant in frame). Light parallax on opacity + a small
  // vertical settle as each stop comes into view, anchored to its own
  // "landed" progress point (no more overrunning the timeline's 0-1 range).
  stops.forEach((stop) => {
    const city = stop.querySelector('.wt-city-inner');
    if (!city) return;

    const landed = panels.indexOf(stop) * SEG;
    const enter = Math.max(0, landed - SEG * 0.6);
    const dur = landed - enter;
    if (dur <= 0) return;
    tl.fromTo(city,
      { opacity: 0, y: 22 },
      { opacity: 0.94, y: 0, ease: 'power1.out', duration: dur },
      enter
    );
  });

  // ---- TRANSITIONS (each pair distinct) ----
  // Panel i occupies progress window centered at i*SEG. Transition i→i+1 spans
  // roughly [i*SEG + SEG*0.5, (i+1)*SEG - SEG*0.1]... we use anchor points below.
  const t = (i) => i * SEG; // progress when panel i is fully centered

  // Intro → Amazon: simple (part of core scroll, no special overlay)

  // 1) Amazon(1)→Sahara(2): clean crossfade (opacity/brightness/scale only).
  //    Previously used a solid green rectangle wipe here that flashed as an
  //    ugly full-screen green screen mid-transition -- removed. Same
  //    GPU-cheap treatment as the other simplified transitions, keeps the
  //    whole tour feeling seamless/transitionless per client direction.
  const amazon = stops[0], sahara1 = stops[1];
  tl.fromTo(amazon.querySelector('.wt-video'),
      { filter: 'brightness(0.8)', scale: 1, opacity: 1 },
      { filter: 'brightness(1.1)', scale: 1.05, opacity: 0.3, ease: 'sine.in', duration: SEG * 0.5 },
      t(1) + SEG * 0.4)
    .fromTo(sahara1.querySelector('.wt-video'),
      { filter: 'brightness(0.55)', scale: 1.04, opacity: 0.3 },
      { filter: 'brightness(0.8)', scale: 1, opacity: 1, ease: 'sine.out', duration: SEG * 0.5 },
      t(1) + SEG * 0.55);

  // 2) Sahara(2)→Jungle(3): heat-shimmer crossfade — outgoing panel dims/scales
  //    (kept GPU-cheap: opacity + scale + brightness only, no live blur filter
  //    during scrub — blur-during-scroll is a common cause of jank/stutter)
  const sahara = stops[1], jungle = stops[2];
  tl.fromTo(sahara.querySelector('.wt-video'),
      { filter: 'brightness(0.8)', scale: 1, opacity: 1 },
      { filter: 'brightness(1.15)', scale: 1.06, opacity: 0.4, ease: 'sine.in', duration: SEG * 0.5 },
      t(2) + SEG * 0.4)
    .fromTo(jungle.querySelector('.wt-video'),
      { filter: 'brightness(0.55)', scale: 1.05, opacity: 0.4 },
      { filter: 'brightness(0.8)', scale: 1, opacity: 1, ease: 'sine.out', duration: SEG * 0.5 },
      t(2) + SEG * 0.55);

  // 3) Jungle(3)→Ocean(4): clean crossfade (opacity/brightness/scale only).
  //    Previously used a solid blue rectangle wipe here that flashed as an
  //    ugly full-screen blue screen mid-transition -- removed, same fix
  //    as the earlier Amazon->Sahara green-screen issue. Consistent
  //    GPU-cheap crossfade treatment across the whole tour now.
  const jungle2 = stops[2], ocean1 = stops[3];
  tl.fromTo(jungle2.querySelector('.wt-video'),
      { filter: 'brightness(0.8)', scale: 1, opacity: 1 },
      { filter: 'brightness(1.1)', scale: 1.05, opacity: 0.3, ease: 'sine.in', duration: SEG * 0.5 },
      t(3) + SEG * 0.4)
    .fromTo(ocean1.querySelector('.wt-video'),
      { filter: 'brightness(0.55)', scale: 1.04, opacity: 0.3 },
      { filter: 'brightness(0.8)', scale: 1, opacity: 1, ease: 'sine.out', duration: SEG * 0.5 },
      t(3) + SEG * 0.55);

  // 4) Los Angeles(4)→Dubai(5): clean crossfade (opacity/brightness/scale only),
  //    same treatment as the other transitions. Previously had a hard neon
  //    flash-cut + glitch chip effect left over from the old Ocean->Tokyo
  //    pairing -- removed, it looked like a jarring blue flash against the
  //    LA/Dubai desert-sunset footage.
  const la2 = stops[3], dubai1 = stops[4];
  tl.fromTo(la2.querySelector('.wt-video'),
      { filter: 'brightness(0.8)', scale: 1, opacity: 1 },
      { filter: 'brightness(1.1)', scale: 1.05, opacity: 0.3, ease: 'sine.in', duration: SEG * 0.5 },
      t(4) + SEG * 0.4)
    .fromTo(dubai1.querySelector('.wt-video'),
      { filter: 'brightness(0.55)', scale: 1.04, opacity: 0.3 },
      { filter: 'brightness(0.8)', scale: 1, opacity: 1, ease: 'sine.out', duration: SEG * 0.5 },
      t(4) + SEG * 0.55);

  // 5) Dubai(5)→Paris(6): clean crossfade (opacity/brightness/scale only).
  //    Previously a light-trail horizontal stretch left over from the old
  //    Tokyo->Vegas pairing -- swapped for the same consistent crossfade.
  const dubai2 = stops[4], paris1 = stops[5];
  tl.fromTo(dubai2.querySelector('.wt-video'),
      { filter: 'brightness(0.8)', scale: 1, opacity: 1 },
      { filter: 'brightness(1.1)', scale: 1.05, opacity: 0.3, ease: 'sine.in', duration: SEG * 0.5 },
      t(5) + SEG * 0.4)
    .fromTo(paris1.querySelector('.wt-video'),
      { filter: 'brightness(0.55)', scale: 1.04, opacity: 0.3 },
      { filter: 'brightness(0.8)', scale: 1, opacity: 1, ease: 'sine.out', duration: SEG * 0.5 },
      t(5) + SEG * 0.55);

  // Intro headline: split each word-line into chars, launch each char from
  // a wide V-shaped wingspan position (outer chars flung far left/right +
  // down, center chars barely displaced) so the whole headline visually
  // converges into a V that closes up into readable text -- like a flock
  // of birds migrating into formation. Distinct from every other chapter's
  // text-reveal treatment on this page.
  // All of this is scrubbed INSIDE the master pinned timeline (tl) across
  // the INTRO_HOLD window (0 -> INTRO_HOLD), so it actually plays out while
  // the section is pinned on screen -- not before the pin engages.
  try {
  const vHeadline = document.getElementById('wtVHeadline');
  if (vHeadline) {
    const lines = gsap.utils.toArray('.wtv-line', vHeadline);
    // Walk each line's existing child nodes (plain text + any nested
    // color-highlight spans like .hl-gold) and rebuild it as individual
    // .wtv-char spans -- carrying the highlight class per-character so
    // colored words (e.g. "STORE." / "YDG WRLD IS") keep their wine-red
    // color even though the whole line gets split into flying chars.
    lines.forEach((line) => {
      const nodes = [...line.childNodes];
      line.innerHTML = '';
      nodes.forEach((node) => {
        const isHighlight = node.nodeType === 1 && node.classList && node.classList.contains('hl-gold');
        const text = node.textContent;
        [...text].forEach((ch) => {
          const span = document.createElement('span');
          span.className = 'wtv-char' + (isHighlight ? ' hl-gold' : '');
          span.textContent = ch === ' ' ? '\u00A0' : ch;
          line.appendChild(span);
        });
      });
    });

    // Only the first couple characters of line 1 get a tiny head-start
    // the instant the section peeks onto screen -- just enough to signal
    // "something's happening here, keep going" without the whole
    // headline being finished before the user even arrives. The rest
    // (remaining chars of line 1 + all of line 2) converges later, tied
    // to actual scroll progress in the scrub timeline below.
    const HEAD_START_COUNT = 3;
    // Each character gets its own randomized starting point scattered
    // widely across the whole screen (not a tidy wingspan) -- like a
    // puzzle where every piece flies in from a different spot and locks
    // into place. Seeded per-char so it's stable across re-renders.
    lines.forEach((line, li) => {
      const chars = gsap.utils.toArray('.wtv-char', line);
      const puzzleFrom = chars.map(() => ({
        x: (Math.random() - 0.5) * window.innerWidth * 0.9,
        y: (Math.random() - 0.5) * window.innerHeight * 0.7,
        rotate: (Math.random() - 0.5) * 220,
      }));
      gsap.set(chars, {
        x: (i) => puzzleFrom[i].x,
        y: (i) => puzzleFrom[i].y,
        rotate: (i) => puzzleFrom[i].rotate,
        opacity: 0,
      });
      if (li === 0) {
        gsap.to(chars.slice(0, HEAD_START_COUNT), {
          x: 0, y: 0, rotate: 0, opacity: 1,
          duration: 0.6,
          ease: 'power3.out',
          stagger: { each: 0.08, from: 'random' },
          scrollTrigger: {
            trigger: '#worldtour',
            start: 'top 95%',
            toggleActions: 'play none none reverse',
          },
        });
      }

      // Remaining chars converge on scroll, once pinned (scrubbed) --
      // each piece flying in from its own random spot, landing at a
      // random moment (not left-to-right), so it reads as puzzle pieces
      // snapping together rather than a scanning reveal. Line 1
      // ("...STORE.") converges first, line 2 ("...EVERYWHERE.") right
      // after -- both fully complete with hold time before the track
      // slides at INTRO_HOLD.
      const remaining = li === 0 ? chars.slice(HEAD_START_COUNT) : chars;
      const lineStart = li === 0 ? INTRO_HOLD * 0.02 : INTRO_HOLD * 0.28;
      tl.to(remaining, {
        x: 0, y: 0, rotate: 0, opacity: 1,
        duration: INTRO_HOLD * 0.2,
        ease: 'power2.out',
        stagger: { each: 0.003, from: 'random' },
      }, lineStart);
    });
    // Hard safety net: force every char fully snapped to place well before
    // INTRO_HOLD ends, so no straggler is ever still mid-flight when the
    // track starts sliding to the next city.
    tl.set('.wtv-char', { x: 0, y: 0, rotate: 0, opacity: 1 }, INTRO_HOLD * 0.6);
  }

  // Globe-grid backdrop: fades in behind the headline and keeps slowly
  // rotating/drifting for a persistent "spinning world" cue while pinned.
  const globeGrid = document.getElementById('wtGlobeGrid');
  if (globeGrid) {
    tl.to(globeGrid, {
      opacity: 1,
      duration: INTRO_HOLD * 0.4,
      ease: 'power1.out',
    }, 0)
    .to(globeGrid, {
      rotate: 130,
      x: '-4%',
      ease: 'none',
      duration: 1,
    }, 0);
  }

  // Intro sub-copy + scroll hint: settle in right after the headline
  // finishes converging in the scrub timeline.
  tl.fromTo('.wt-intro-sub, .wt-scroll-hint', {
    opacity: 0,
    y: 26,
  }, {
    opacity: 1,
    y: 0,
    stagger: 0.08,
    duration: INTRO_HOLD * 0.25,
    ease: 'power2.out',
  }, INTRO_HOLD * 0.55);
  } catch (e) {
    console.error('worldTour intro V-headline block failed:', e);
    window.__wtvErr = e.message + ' | ' + e.stack;
  }
})();

// ============================================================
// CART BADGE SYNC (additive — do not remove or modify above)
// Reads the real Shopify cart (via window.YDGCart, Storefront API)
// and updates #navCartCount on index.html so the count stays in
// sync with product.html / shop.html.
// ============================================================
(function syncCartBadge() {
  function getCartCount() {
    const cart = window.YDGCart && window.YDGCart.getCached();
    return cart ? (cart.totalQuantity || 0) : 0;
  }
  function updateBadge() {
    const el = document.getElementById('navCartCount');
    const link = document.getElementById('navCartLink');
    const count = getCartCount();
    if (el) {
      el.textContent = count;
      el.style.opacity = count > 0 ? '1' : '0';
    }
    if (link) {
      const url = window.YDGCart && window.YDGCart.getCheckoutUrl();
      link.href = (count > 0 && url) ? url : '/pages/shop';
    }
  }
  updateBadge();
  if (window.YDGCart) {
    window.YDGCart.onChange(updateBadge);
  }
})();

// ============ SHOWCASE — corkboard polaroids pin in on scroll ============
(function corkboardPin() {
  const board = document.getElementById('corkboard');
  if (!board) return;
  const cards = gsap.utils.toArray('.polaroid', board);

  // Apply each card's fixed rotation as a CSS var (kept off the base
  // transform so the hover scale/rotate-to-0 tween doesn't fight it).
  cards.forEach((card) => {
    const deg = card.dataset.rot || 0;
    card.style.setProperty('--r', deg + 'deg');
  });

  // Pin-in entrance: cards drop into place staggered as the section scrolls
  // into view, like they're being tacked up one at a time. Rotation stays
  // CSS-driven (var(--r)) so it never fights the hover un-rotate tween;
  // GSAP only animates opacity/position/scale here.
  gsap.from(cards, {
    opacity: 0,
    y: -60,
    scale: 0.7,
    duration: 0.5,
    ease: 'back.out(1.6)',
    stagger: { each: 0.045, from: 'random' },
    clearProps: 'transform',
    scrollTrigger: {
      trigger: board,
      start: 'top 85%',
    },
  });
})();
